import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $messageCentreStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { MessageThread, NewMessage } from './widgets';
import { MessageTemplates, PageContainer, View } from '@widgets';
import { Spinner } from '@shared/widgets';

export const MessageCenterPage = () => {
  const messageCentreStore = useUnit($messageCentreStore.store);

  const [isFirstLoading, setIsFirstLoading] = useState<boolean>(true);

  const { t } = useTranslation('messageCenter');

  const isLoading = isFirstLoading && messageCentreStore.firstLoading;
  useEffect(() => {
    // Auto update threads every 60sec
    $messageCentreStore.events.getThreads();
    const intervalId = setInterval(() => {
      if (isLoading) return;
      setIsFirstLoading(false);
      $messageCentreStore.events.getThreads();
    }, 60000);

    return () => {
      clearInterval(intervalId);
      $messageCentreStore.events.clear();
    };
  }, []);

  return (
    <PageContainer title={t('title')} header={t('header')}>
      {messageCentreStore.loading && <Spinner position />}
      <main className={cn('flex gap-8', PaletteUtils.isVcfcPalette && 'max-md:flex-col max-md:gap-4')}>
        <div className='flex flex-1 flex-col gap-4'>
          <MessageTemplates />
          <View
            loading={isLoading}
            error={messageCentreStore.error}
            onRefresh={() => $messageCentreStore.events.getThreads()}
            noData={!messageCentreStore.data.length}
          >
            <div className='flex flex-col gap-2'>
              {messageCentreStore.data?.map((thread) => <MessageThread key={thread.groupId} thread={thread} />)}
            </div>
          </View>
        </div>
        <NewMessage className={cn('h-fit w-80 flex-none', PaletteUtils.isVcfcPalette && 'max-md:w-full')} />
      </main>
    </PageContainer>
  );
};
